export default class Frames {
    static run({images, keytime, tweentime, isOscillated}) {
        let time = 0
        let frames = []
        images.forEach((image, index) => {
            frames.push({
                "time": time,
                "image": image,
            })
            time += tweentime
        })

        if(isOscillated != true) {
            frames.push({
                "time": time,
                "image": images[images.length - 1],
            })
            time += tweentime
        }

        if(isOscillated == true) {
            images.reverse().forEach((image, index) => {
                if(index == 0) {
                    return
                }
                frames.push({
                    "time": time,
                    "image": image,
                })
                time += tweentime
            })
        }
        return frames
    }
}
